<template>
  <div v-if="jobs.length" class="global-ocr-toast-stack">
    <div
      v-for="job in jobs"
      :key="job.id"
      class="global-ocr-toast"
      :class="'global-ocr-toast--' + job.status"
    >
      <div class="global-ocr-toast-body">
        <span v-if="job.status === 'processing'" class="global-ocr-toast-spinner"></span>
        <span v-else-if="job.status === 'done'" class="global-ocr-toast-icon global-ocr-toast-icon--done">✓</span>
        <span v-else class="global-ocr-toast-icon global-ocr-toast-icon--error">✕</span>
        <div class="global-ocr-toast-text">
          <div class="global-ocr-toast-title">{{ jobTitle(job) }}</div>
          <div v-if="job.status === 'done' && job.failedCount" class="global-ocr-toast-sub">일부 캡처 실패 ({{ job.failedCount }}건)</div>
          <div v-if="job.status === 'error'" class="global-ocr-toast-sub global-ocr-toast-sub--error">{{ job.error }}</div>
        </div>
      </div>
      <div class="global-ocr-toast-actions">
        <span v-if="job.status === 'done'" class="global-ocr-toast-link" @click="goToJob(job)">바로가기</span>
        <span class="global-ocr-toast-close" @click="dismiss(job.id)">✕</span>
      </div>
    </div>
  </div>
</template>

<script>
const FIELD_LABEL_MAP = {
  title_text: '문제',
  view_text: '보기',
  table_text: '선지 표',
  sequence_text: '지문',
}

export default {
  name: 'GlobalOcrJobToast',
  computed: {
    jobs() {
      return this.$store.state.aiJob.jobs
    },
  },
  methods: {
    jobTitle(job) {
      const fieldLabel = job.fieldLabel || FIELD_LABEL_MAP[job.field] || job.field
      const qLabel = job.questionNumber != null ? `${job.questionNumber}번 문제` : '문제'
      const actionLabel = job.actionLabel || '텍스트화'
      if (job.status === 'processing') return `${qLabel} ${fieldLabel} ${actionLabel} 처리 중...`
      if (job.status === 'done') return `${qLabel} ${fieldLabel} ${actionLabel} 완료`
      return `${qLabel} ${fieldLabel} ${actionLabel} 실패`
    },
    goToJob(job) {
      if (job.source === 'question_pool') {
        // 이 페이지는 $route.params.id 하나로 문제를 특정하므로 router.push만으로 충분하다.
        const path = job.sourcePath || `/admin/question-pool/edit/${job.questionId}`
        if (this.$route.path !== path) this.$router.push(path)
        this.dismiss(job.id)
        return
      }

      // 이 화면(ExamEdit)은 URL이 아니라 Vuex 상태(exam/activeQuestion 등)가 기준이라,
      // 이미 같은 시험을 보고 있는 중이면 router.push로 쿼리만 바꿔봐야 화면이 안 바뀐다.
      // 같은 시험이면 이미 있는 문제 전환 로직(SET_ACTIVE_QUESTION_INDEX)을 그대로 태우고,
      // 다른 시험이거나 이 페이지가 아니면 새로 진입해야 하므로 하드 네비게이션으로 확실히 이동시킨다.
      const activeExam = this.$store.state.exam.activeExam
      const onExamEditRoute = this.$route.path === '/exam/admin-question-edit-ai/v2'

      if (onExamEditRoute && activeExam && String(activeExam.id) === String(job.examSubjectId)) {
        this.$store.commit('exam/SET_ACTIVE_QUESTION_INDEX', job.questionIndex)
      } else {
        const params = new URLSearchParams()
        params.set('exam', String(job.examSubjectId))
        params.set('type', String(job.examType))
        params.append('question', String(job.questionId))
        params.append('question', String(job.questionIndex))
        window.location.href = `/exam/admin-question-edit-ai/v2?${params.toString()}`
      }
      this.dismiss(job.id)
    },
    dismiss(id) {
      this.$store.commit('aiJob/REMOVE_JOB', id)
    },
  },
}
</script>

<style scoped>
.global-ocr-toast-stack {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 360px;
}

.global-ocr-toast {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  background: white;
  border-radius: 8px;
  padding: 12px 14px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  border-left: 4px solid #9ca3af;
}

.global-ocr-toast--processing {
  border-left-color: #4285f4;
}

.global-ocr-toast--done {
  border-left-color: #10b981;
}

.global-ocr-toast--error {
  border-left-color: #ef4444;
}

.global-ocr-toast-body {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.global-ocr-toast-spinner {
  flex-shrink: 0;
  width: 14px;
  height: 14px;
  margin-top: 2px;
  border: 2px solid #dbeafe;
  border-top-color: #4285f4;
  border-radius: 50%;
  animation: global-ocr-toast-spin 0.8s linear infinite;
}

@keyframes global-ocr-toast-spin {
  to {
    transform: rotate(360deg);
  }
}

.global-ocr-toast-icon {
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  margin-top: 1px;
}

.global-ocr-toast-icon--done {
  color: #10b981;
}

.global-ocr-toast-icon--error {
  color: #ef4444;
}

.global-ocr-toast-text {
  min-width: 0;
}

.global-ocr-toast-title {
  font-size: 13px;
  font-weight: 600;
  color: #262626;
  word-break: keep-all;
}

.global-ocr-toast-sub {
  font-size: 11px;
  color: #9ca3af;
  margin-top: 2px;
}

.global-ocr-toast-sub--error {
  color: #ef4444;
}

.global-ocr-toast-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.global-ocr-toast-link {
  font-size: 12px;
  font-weight: 700;
  color: #4285f4;
  cursor: pointer;
  white-space: nowrap;
}

.global-ocr-toast-close {
  font-size: 12px;
  color: #9ca3af;
  cursor: pointer;
}
</style>
